<template>
  <div class="privacy">
    <h2>Privacy Policy</h2>
    <h2>Last Updated: [2th November, 2022]</h2>

    <p>
      Hong Kong Hookylin Techonology Limited (Hereinafter referred to as “the Company” or “we”) is concerned with the
      protection of personal information of members ("you" or "user") who access and/or use our games, whether played on
      our website, on mobile devices, PCs or on other platforms, and other related services, including but not limited
      to customer supporting, marketing and advertising, (collectively, “the Service” or “our services”), and complies
      with any law and regulation established by related organizations.
    </p>

    <p>
      Through this Privacy Policy you will know about how and where the personal information provided by the user is
      used, and how the Company is making efforts to protect the personal information of users.
    </p>

    <h3>1. Personal information we collect and process</h3>

    <h4>1.1 Items of collecting and using personal information:</h4>
    <p>
      A) Name;<br />
      B) Registered user name and password;<br />
      C) Contact information (e.g. personal identification number, postal or e-mail address, telephone numbers);<br />
      D) Mobile device’s model name, OS information, OS version, device identification number (device ID or IMEI, UUID,
      UDID, etc.), Mac address, service providers’ information, IP address;<br />
      E) GPS location information, base station location information, WIFI-AP information;<br />
      F) Encrypted personal identification information, duplicate registration confirmation information, date of birth,
      gender information, foreigner information;<br />
      G) Billing and financial information (Please be reminded that the use of any merchant service provider and/or
      third party platforms for the payment of the Admission Fee is subject to the privacy policy of the relevant
      merchant service providers and/or third party platforms);<br />
      H) Game Invitation ID (for games with game invitation only);<br />
      I) Data we receive if you link a third-party tool with the Service (such as Facebook, Google, etc.). The
      information we collect when you link a third-party tool with the Service may include: (1) your name, (2) your user
      identification number and/or user name, (3) locale, city, state and country, (4) sex, (5) birth date, (6) email
      address, (7) profile picture or its URL, and (8) the user identification numbers for your friends that are also
      connected to the Company's game(s); <br />
      J) Survey Information, namely the content of your survey responses if you agree to participate in such surveys.<br />
      K) Game data, namely your interactions with the game and with other players in the game.<br />
    </p>

    <h4>1.2 Methods of collecting and using personal information:</h4>
    <p>
      Cooperation company such as certification authorities, collection via mobile device and server log files, your
      access and participation in message boards on the Service.
    </p>
    <p>
      Users may refuse to provide the above personal information. However, if you refuse to provide personal
      information, some or all services may not be available.
    </p>

    <h3>2. Purpose of collecting and using personal information</h3>

    <p>
      The Company distinguishes personal information collected/provided between requiring consent and not requiring
      consent when processes it as below. The purpose of using each item is as follows.
    </p>

    <h4>2.1 Items requiring user’s consent</h4>
    <p>
      A) User ID, mobile phone number, email address connected Social Media Account Information (Third Party): personal
      identification based on service use, bad user management, complaint handling and other customer service delivery,
      notice delivery, payment service verification and confirmation;<br />
      B) Password: confirm access authority by using service;<br />
      C) GPS position information, base station information (cell-id), WIFI-AP (only for content with location-based
      services): coordinate measurement for location-based services.<br />
      D) Device identification number, MAC address: new service, event information guide (push notification), personal
      identification and rogue user management;<br />
      E) Mobile device’s model name, OS information, OS version, service providers’ information: service quality
      improvement and statistical information process<br />
      F) IP address: abnormal user detection and use restriction, contract execution, dispute handling, etc.;<br />
      G) Payment data (your name, bank card number, bank card validity period, billing address, CVV, etc.): payment
      service verification and confirmation;<br />
      H) Survey Information: personalized experience, latest product announcements;
    </p>

    <h4>2.2 Items not requiring user’s consent</h4>
    <p>
      A) Access record (visit date, etc.): service quality Improvement, execute contract and dispute settlement;<br />
      B) Payment information: customer service about charge settlement of paid service;<br />
      C) Game Invitation ID: identifying invitation user information and paying reward when inviting game;<br />
      D) Game data: providing feedback and information about your gameplay and progress, service quality Improvement,
      protecting the integrity, safety, and security of the Service or users.
    </p>

    <h4>2.3 Used items provided by cooperation companies</h4>
    <p>
      Only for content that has a separate authentication service. Duplicate registration confirmation information/date
      of birth/gender information/foreigner information, etc. are provided from the certification body when the
      applicant is authenticated. It is used for the following purposes.
    </p>
    <p>
      A) Name/Encrypted Personal Identification Information/Duplicate Subscription Confirmation Information:
      Identification of identity, duplicate registration confirmation<br />
      B) Date of birth: Age verification;<br />
      C) Gender Info: Gender Confirmation;<br />
      D) Foreigner Information: Native/Foreigner Confirmation;<br />
      E) Information of refund abuse in games or click fraud in advertising: Dealing with and preventing fraud;<br />
      F) Information from platforms that the game runs on: Payment verification and confirmation;<br />
      G) Other Information: Advertising and analytic purposes.
    </p>

    <p>
      In all of the above items and purposes, you acknowledge and confirm that we may analyze, profile, segment, merge
      and/or update all collected information (regardless of an aggregated or individualized manner) for the purposes of
      improving service quality and providing a better experience.
    </p>

    <p>
      In specific cases, we may collect other personal information apart from the categories stated herein based on your
      consent. When this occurs, we will, upon requiring your additional consent, provide more information about any
      change to the way or purpose of our collection or processing which might be different from or not clarified in the
      details in this Privacy Policy.
    </p>

    <h4>
      2.4 Please understand that, in accordance with laws and regulations and relevant national standards, we do not
      require your consent to collect and use your personal information in the following circumstances.
    </h4>
    <p>
      A) To perform our obligations under laws and regulations.<br />
      B) To protect national security or national defense security;<br />
      C) To protect public safety, public health, or major public interests;<br />
      D) Related to criminal investigation, prosecution, trial and enforcement of judgments, etc;<br />
      E) To protect your or any individuals’ major legitimate rights or interests such as life and property of the
      information subject or other individuals, while it is difficult to obtain your consent;<br />
      F) The information collected is disclosed to the public by you;<br />
      G) Collecting information from lawfully and publicly disclosed information, such as lawful news reports, open
      government information, and other such channels;<br />
      H) Necessary for signing a contract according to your requirements;<br />
      I) Necessary for maintaining the safe and stable operation of our services, such as discovering and disposing of
      the failure of products or services;<br />
      J) Necessary for lawful news reporting;<br />
      K) Necessary for an academic research institution to carry out statistical or academic research based on the
      public interest, and the information contained in the results is de-identified when provided to the outside
      world;<br />
      L) Other situations stipulated by laws and regulations.
    </p>

    <h3>3. Sharing and Providing Personal Information</h3>

    <h4>
      3.1 The Company shall use the personal information of the users within the purpose for which it was notified at
      the time of collection and in principle shall not disclose the user's personal information to the outside without
      prior consent of the user. However, except as follows:
    </h4>
    <p>
      A) If a user agrees to disclose in advance. <br />
      B) If sharing is necessary to fulfill legal obligations.<br />
      C) If there are enough grounds to believe that you should disclose your personal information in order to take
      legal action against it by giving mental and material damage to others using the Service.<br />
      D) If sharing is necessary for the conclusion and performance of a contract to which you are a party.<br />
      E) If it is determined in good faith that it is required by other laws.
    </p>

    <h4>3.2 To whom we share your personal information</h4>
    <p>
      A）Other In-Game users of the Service<br />
      Other users may, for example, in a teamed challenge, access your in-game activities in the process of such teamed
      challenge. Other users may also see your displayed data and read the messages you have posted on or through our
      services. You acknowledge and agree that our services may also include message boards, communities, forums, and/or
      other chat areas, where users may exchange ideas or communicate with other users, and that any data you post to
      any communication area is publicly viewable. We strongly recommend that all users avoid posting personal or
      sensitive data at any time on or through the Service.
    </p>
    <p>
      B) Competent Authorities<br />
      We may provide a certain portion of your personal data to judicial or administrative authorities as so requested.
      Besides, we may disclose certain portion of your personal data within a strictly limited scope of recipients when
      we reasonably think it is necessary to protect us, our users or a portion of the public.<br />
      In addition to be required by applicable laws, we reserve the right to disclose your personal data in the cases if
      we, in our good faith, believe that disclosing such data is necessary to identify, contact, or bring legal action
      against you, if (a) you are violating any other agreement(s) between you and us, such as the Terms of Service,
      this Privacy Policy or otherwise damage us; (b) you are infringing third-parties’ rights and interests (including
      but not limited to intellectual property rights); and/or (c) we believe that it is necessary to prevent fraud or
      other illegal activities.
    </p>
    <p>
      C) Our personnel, related or affiliated companies<br />
      We may provide your personally identifiable information and non-personally-identifiable information to our
      personnel, our related or affiliated companies for our legitimate business purposes. We may also provide your
      personally identifiable information and non-personally-identifiable information to other businesses or persons for
      the purpose of processing such information or otherwise assist us in performing any services on our behalf
      including in any advertising and marketing activities. We require that these parties agree to process such
      information in compliance with our Privacy Policy contained herein, and we will use reasonable efforts to limit
      their use of such information and to use other appropriate confidentiality and security measures.
    </p>
    <p>
      D) Third-Party Contractors<br />
      We work with a number of (if any) third parties on or through our services to help us provide services and
      functionalities to you. We do not sell your personal data and only share data that is non-personally identifiable
      on its own, aggregated, or public with third parties under the following necessary circumstances, and such
      third-parties thereof are prevented from processing (including but not limited to accessing, storing, using, or
      disclosing) your personal data except for achieving the purpose of their cooperation with us:<br />
      i. Social networking portals who provide login and/or content-sharing service to and in our services;<br />
      ii. Logistics service providers who provide shipping services such as delivering physical prizes to users;<br />
      iii. Information communication service providers who provide SMS-messaging services;<br />
      iv. Payment service providers who provide payment services, such as assisting our services to run on, facilitating
      users’ payment, and maintaining a record of the users’ transaction history;<br />
      v. Advertising service contractors who provide marketing and advertising activities, including conducting the
      programs, tracking the success, and analyzing the effect thereof;<br />
      vi. Other contractors if any for the purpose of providing our services to you.<br />
      Please note that your use of such third parties' services (including any information you provide to such third
      parties) is subject to the third parties' own terms of service and information protection statements (not this
      Policy), the terms of which you need to read carefully. This Policy applies only to the personal information we
      collect and does not apply to services provided by any third party or to the rules governing the use of
      information by third parties.
    </p>

    <h4>3.3 Entrusted processing</h4>
    <p>
      We may entrust the processing of your personal information to authorized partners in order to provide certain
      services or perform functions for you on our behalf. We will only entrust them with your information for the
      lawful, legitimate, necessary, specific and defined purposes stated in this policy, and the authorized partners
      will only have access to the information necessary to perform their duties. In addition, we will require by
      agreement that they will not use this information for any other purpose beyond the scope of the delegation. If an
      authorized partner uses your information for a purpose that we have not delegated, it will obtain your consent
      separately.
    </p>

    <h4>3.4 Transfer</h4>
    <p>
      If we need to transfer personal information due to merger, separation, dissolution, or being declared bankrupt, we
      will inform you of the name and contact information of the recipient. The recipient will continue to fulfill this
      policy and other legal obligations. If the recipient changes the original purpose or method of processing, we will
      obtain your consent again.
    </p>

    <h4>3.5 Public disclosure</h4>
    <p>
      We will only publicly disclose your personal information when:<br />
      A) based on your active choice and separate consent.<br />
      B) we determine that you have violated laws and regulations or seriously violated relevant agreements and rules
      with us, or to protect the personal and property safety of our users or the public from infringement, we may
      disclose personal information about you, including relevant violations and the measures we have taken against you.
    </p>

    <h3>4. Retention and Period of use of Personal Information</h3>
    <p>
      Personal information collected with your consent will be retained and used while your account is active or only
      for as needed to provide you our services, and if requested to be revoked, it will be permanently deleted from the
      disk by a method that can not be reproduced and processed in a state that can not be viewed or accessed later.
      Please note that the removal or deletion of any of your data may result in the termination of some of our
      applicable services.
    </p>

    <p>
      We will only store your information as long as necessary to fulfil the purposes for which the information is
      collected and processed or where the applicable law provides for longer storage and retention period. Upon the
      expiration of such period, your personal data will be deleted, blocked or anonymized, as provided by applicable
      law.
    </p>

    <p>
      You acknowledge and agree that your data will be processed on our servers which may not be located in your country
      of residence and can be accessed by our support, engineering and/or our affiliates around the world. No matter
      where our servers are located, we will make great efforts to take the appropriate safeguards to guarantee your
      rights in conformity with this Privacy Policy and any applicable laws.
    </p>

    <h3>5. Procedures and methods of destroying personal information</h3>
    <p>
      The personal information of the user is destroyed without delay when the purpose of collection and use is
      achieved, and the destruction procedures and methods are managed according to the following standards.
    </p>

    <h4>5.1 Destruction procedure</h4>
    <p>
      Information collected or used by the Company, such as information entered by a user for account or information
      provided by affiliates such as the principal's confirmation agency, will be stored and stored for the period of
      storage under internal policies and other related laws after the purpose of use is achieved.
    </p>

    <h4>5.2 Destruction methods</h4>
    <p>
      i. Personal information printed on paper is crushed by crusher or destroyed by incineration.<br />
      ii. Personal information records stored in electronic files are deleted by technical methods that can not be
      reproduced.
    </p>

    <h3>6. Rights of Users</h3>

    <h4>6.1 Opt out of advertising and/or marketing materials</h4>
    <p>
      You may opt out of receiving advertising and/or marketing communications by following the instructions in such
      communications or by using options provided in the settings in the game or on your devices.
    </p>

    <h4>6.2 Correct or modify the personal data we hold about you</h4>
    <p>
      You have the right to access and correct your personal data through contacting us at cs_na@flame-games.com. Upon
      receiving your request via email, we will promptly conduct a verification process including but not limited to
      instructing you to provide information to confirm that you are the user from whom we have collected information.
      If you request correction of an error in personal information, we will not use or provide the personal information
      until the correction is completed. Also, if wrong personal information has already been provided to a third party,
      we will notify the third party without delay and correct the processing result.
    </p>

    <h4>6.3 Withdrawal of consent</h4>
    <p>
      You have the right to turn off the relevant permission in the device's own operating system, change the scope of
      consent or withdraw your authorization. After withdrawing your authorization we will no longer collect information
      related to this permission.
    </p>

    <h4>6.4 Cancellation of account</h4>
    <p>
      You have the right to cancel your account through contacting us via email at cs_na@flame-games.com, and after your
      cancellation, we will stop providing you with products or services and will delete or anonymize your personal
      information as required by applicable law. Please be attention that account cancellation is irreversible.
    </p>

    <h4>6.5 Other rights</h4>
    <p>
      You also have the right to have your personal data deleted, object how we use or share your personal data, and
      restrict how we use or share your personal data. You can always withdraw your consent.
    </p>

    <p>
      The Company treats personal information that has been terminated or deleted at the request of its users or legal
      representatives to be processed as described in 4. Retention and Period of use of Personal Information and is
      prohibited from being viewed or accessed for other purposes.
    </p>

    <h3>
      7. Matters concerning the installation/operation and rejection of automatic collection of personal information
    </h3>

    <p>
      The Company uses "cookies" to store and retrieve user information to provide customized services to users. A
      cookie is a very small text file that a server used to run a service sent to a user's mobile device and is stored
      on the user's mobile device. After that, when the user uses the service, the server reads the content of the
      cookie stored in the user's mobile device, confirms the information of the user, and provides customized services.
    </p>

    <p>
      The Company uses cookies for customized services, such as linking user profile information, and users have the
      option of installing cookies. Users can set whether or not to accept cookies in their mobile device's settings,
      and they can also delete cookies. However, if you do not allow the use of cookies, you may have difficulty using
      the Service when you need to login.
    </p>

    <h3>8. Technical and administrative protection measures of personal information</h3>

    <p>
      In dealing with the personal information of the user, the Company takes the following technical and managerial
      measures in order to secure the personal information without being lost, stolen, leaked, altered or damaged.
    </p>

    <p>
      The Company is doing its best to prevent leakage or damage of personal information of users by hacking or computer
      virus. We make backups of data at any time in preparation for the compromise of personal information. We use the
      latest vaccine program to prevent personal information or data from being leaked or damaged, and we can securely
      transmit personal information over the network through encryption algorithms. We use intrusion prevention system
      to control unauthorized access from the outside, and try to have all possible technical devices to ensure system
      stability.
    </p>

    <p>
      The Company restricts the handling of personal information of the user to the person in charge and regularly
      renews it with a separate password for this purpose and constantly emphasizes the compliance with the company's
      personal information processing.
    </p>

    <p>
      In addition, through the in-house delegated organization, we check the compliance of the Company's Privacy Policy
      and compliance with the person in charge, and are working to correct and rectify any problems that are found.
    </p>

    <p>
      The services provided by the Company are based on mobile devices. Please be careful not to lose your mobile device
      as personal information may be leaked when you lose your mobile device. It is recommended to set security service
      such as screen lock function or pattern function. In addition, the user's personal information is protected with a
      password, and the user is responsible for managing the user ID and password. The Company shall not be held
      responsible for the problems caused by the leakage of important personal information due to the carelessness of
      the user, such as the user giving the user ID or password to the third party or losing the device.
    </p>

    <p>
      If our physical, technical or management protection facilities are damaged, resulting in unauthorized access,
      public disclosure, tampering or destruction of information, which does damage to your legitimate rights and
      interests, we will promptly start the emergency plan and take reasonable and necessary measures to minimize the
      impact on you. If your personal information is leaked, illegally provided to others or misused, resulting in
      damage to your legitimate rights and interests, we will bear the corresponding responsibility in strict accordance
      with the provisions of the law.
    </p>

    <p>
      If a personal information security incident occurs, we will also inform you of the basic situation and possible
      impact of the security incident, the disposal measures we have taken or will take, the suggestions you can take
      independently to prevent and reduce the risk, and the remedial measures for you in accordance with the
      requirements of laws and regulations. We will inform you by SMS, telephone, push notification and other reasonable
      channels, and if it is difficult to inform you one by one, we will take reasonable and effective ways to publish
      announcements. At the same time, we will also report the disposition of personal information security incidents in
      accordance with the requirements of the regulatory authorities.
    </p>

    <h3>9. Age Limits and Children Protection</h3>

    <p>
      You represent that you are an adult or older in your country of residence (or at other age in your jurisdiction
      where you are classified as a majority) when using our services. If you are a minor child or under the legal age
      of majority ("Minor" or "Child"), please do not send any personal data about yourself to us, including your name,
      address, telephone number, or email address. Notwithstanding the foregoing, we recognize that we have a special
      obligation to protect children in regard to the collection and processing of personal data, and we do not and will
      not knowingly collect personal data from children without consent from their parents or guardians. We strongly
      urge parents and guardians to instruct their children never to disclose or give out their personal data when using
      our services without the prior permission of their parent/guardian. If we learn that we have collected personal
      data about a child, we will delete that data as quickly as possible.
    </p>

    <h3>10. Civil Service on Personal Information</h3>

    <p>
      The Company collects opinions from users regarding personal information of users and has all procedures and
      methods to deal with complaints.<br />
      A) If you have any questions or concerns about any of the matters in relation to this Privacy Policy, including to
      exercise any of your rights, please contact us via email at cs_na@flame-games.com.
    </p>

    <h3>11. Other</h3>

    <h4>
      11.1 The Privacy Policy may be revised, amended or modified due to changes in laws, guidelines or internal
      policies of the Company. We will not reduce your rights under this Privacy Policy without your express consent. We
      will post changes to this Privacy Policy on our website or give you more prominent notice of changes that would
      reduce your rights or increase your obligations. Please re-visit this page to stay in touch with any changes.
    </h4>
    <p>
      Your access of the Services signifies your acceptance and agreement to this Privacy Policy (as may be amended or
      revised from time to time).
    </p>

    <h4>
      11.2 In the event of any dispute between you and us regarding the contents of this Privacy Policy or its
      implementation, the dispute shall be resolved amicably; if it is unable to resolve the dispute amicably, the
      dispute shall be submitted to the Hong Kong International Arbitration Center for arbitration in Hong Kong. The
      arbitration tribunal shall be composed of one person and the arbitration language shall be Chinese. The laws of
      the People's Republic of China shall apply and the application of any other conflict of laws is excluded.
    </h4>

    <h3>12. California</h3>

    <p>This section applies to California residents covered by the California Consumer Privacy Act of 2018 (“CCPA”).</p>

    <h4>12.1 Collection and Disclosure of Personal Information</h4>

    <p>
      Over the past 12 months, we have collected and disclosed the following categories of personal information from or
      about you or your device:<br />
      A) Identifiers, such as your name as it appears on your social media profile, open ID / user ID, IP address, phone
      number, mailing address, email address, and nickname. This information is collected directly from you and your
      device and from social media platforms if you choose to sign up using a social media account.<br />
      B) Internet or other electronic network activity information, such as your information regarding your use of the
      Service, including level, score, date and other device information as described in the main policy. This
      information is collected directly from you and your device.<br />
      C) Commercial information about any transactions within the Service such as what products were purchased and how
      much they cost. This information is collected directly from you and your device and the Google Play or Apple iOS
      store.<br />
      D) Other information described in subdivision (e) of Section 1798.80. This information is collected directly from
      you in the context of being our consumer.
    </p>

    <p>
      We collect your personal information for the following purposes:<br />
      A) To provide you the Service, including offering the Service, maintaining your account, and delivering audio and
      text messages;<br />
      B) To process surveys;<br />
      C) To improve our services, including the functionality of the Service;<br />
      D) For security and verification purposes, including to prevent and detect fraudulent activity;<br />
      E) To address and remediate technical issues and bugs.
    </p>

    <p>
      We disclose personal information to the following types of entities:<br />
      A) Other companies within our corporate group who process your personal information in order to operate the
      Service;<br />
      B) Other companies that provide services on our behalf who are prohibited by contract from retaining, using, or
      disclosing personal information for any purpose other than for providing the services to us;<br />
      C) Regulators and judicial authorities and law enforcement agencies;<br />
      D) Entities that acquire all or substantially all of our business.
    </p>

    <p>
      In the past 12 months, we have not sold Personal Information of California residents within the meaning of "sold"
      in the CCPA.
    </p>

    <h4>12.2 Rights under the CCPA</h4>

    <p>
      If you are a California resident, you have the right to:<br />
      A) Request we disclose to you free of charge the following information covering the 12 months preceding your
      request:<br />
      i. other categories of personal information about you that we collected;<br />
      ii. other categories of sources from which the personal information was collected;<br />
      iii. other purpose for collecting personal information about you;<br />
      iv. other categories of third parties to whom we disclosed personal information about you and the categories of
      personal information that was disclosed (if applicable) and the purpose for disclosing the personal information
      about you; and<br />
      v. othe specific pieces of personal information we collected about you;<br />
      B) Request we delete personal information we collected from you, unless the CCPA recognizes an exception; and<br />
      C) Be free from unlawful discrimination for exercising your rights including providing a different level or
      quality of services or denying goods or services to you when you exercise your rights under the CCPA. <br />
      We aim to fulfill all verified requests within 45 days pursuant to the CCPA. If necessary, extensions for an
      additional 45 days will be accompanied by an explanation for the delay.
    </p>

    <h4>12.3 How to Exercise Your Rights</h4>
    <p>
      First, you may wish to log into your account and manage your data from there. If you are a California resident to
      whom the CCPA applies, you may exercise your rights, if any, regarding other data by contacting us at
      cs_na@flame-games.com.
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.privacy {
  max-width: 800px;
  margin: 0.1rem auto;
  font-family: 'Helvetica Neue', Arial, 'Hiragino Sans GB', 'STHeiti', 'Microsoft YaHei', 'WenQuanYi Micro Hei', SimSun,
    Song, sans-serif;
  color: #2c3f51;
  line-height: 1.8;
  h2 {
    font-size: 22px;
    text-align: center;
  }
  p {
    font-size: 16px;
    margin-top: 20px;
  }
  h3 {
    font-size: 20px;
    margin: 20px 0;
  }
  h4 {
    font-size: 18px;
    margin: 20px 0;
    font-weight: 400;
  }
}
</style>
